/**
 * zh-HK（預設語言）—— **基準字典**
 *
 * ⚠️ 本檔係三語嘅「型別真相源」：`src/i18n.ts` 用 `const _parityEn: typeof zhHK = en`
 *    檢查其他語言 → **缺 key／型別唔同 ＝ build（typecheck）即刻紅** ✗
 * ⚠️ 加 key 一定三語齊＋跑 `npm run build`（內含 `check:locales` 同 `typecheck`）。
 * ⭐ **語體（2026-10-05 產品負責人指定）：一律用「正式書面繁體中文」，唔准用粵語口語。**
 *    即係：嘅→的、咗→了、唔→不、喺→在、佢→他、撳→點按、嚟→來、呢個→這個、冇→沒有…
 *    （例：唔好寫「撳入去」→ 要寫「點按進入」；「你嘅」→「您的」。）
 */
export const zhHK = {


  language_label: '語言',
  locale_zh_hk: '繁體中文（香港）',
  locale_en: 'English',
  locale_zh_cn: '简体中文',

  back_home: '返回首頁',

  login_email: 'Email',
  login_password: '密碼',
  login_submit: '登入',
  login_working: '登入中…',
  login_failed: '登入失敗，請再試。',
  login_phone_ph: '請輸入手機號碼',

  setpw_title: '設定密碼',
  setpw_new: '新密碼（最少 8 個字元）',
  setpw_confirm: '確認密碼',
  setpw_submit: '設定並登入',
  setpw_working: '設定中…',
  setpw_mismatch: '兩次輸入的密碼不一致',
  setpw_nolink: '邀請連結不完整（缺少 token），請使用管理員發出的完整連結。',
  setpw_failed: '設定失敗，請再試。',

  member_title: '會員區',
  member_greeting: '您好，{{email}}',
  member_role: '角色：{{role}}',
  member_todo: '會員功能（會籍／活動／文件／通知）將於 M3 之後逐項加入。',
  logout: '登出',

  'tab.aria': '底部導航',
  'tab.benefits': '優惠',
  'tab.news': '資訊',
  'tab.cards': '我的卡',
  'tab.ads': '廣告',
  'tab.settings': '設定',
  page_todo: '此部分將於 M3 之後實現（現時尚未完成）。',

  admin_title: '管理台',
  admin_members: '會員管理',
  admin_benefits: '優惠管理',
  admin_news: '資訊管理',
  admin_back: '返回會員區',
  btn_new: '新增',
  btn_edit: '編輯',
  btn_delete: '刪除',
  btn_save: '儲存',
  btn_cancel: '取消',
  confirm_delete: '確定刪除？',
  empty_none: '暫無資料',
  col_no: '會員編號',
  col_name: '姓名',
  col_type: '種類',
  col_status: '狀態',
  col_email: 'Email',
  col_phone: '電話',
  col_company: '公司',
  col_title: '標題',
  col_partner: '合作夥伴',
  col_published: '狀態',
  f_title: '標題',
  f_body: '內容',
  f_partner: '合作夥伴',
  f_valid_from: '生效日',
  f_valid_to: '到期日',
  f_name: '姓名',
  f_type: '會籍種類',
  f_company: '公司',
  f_email: 'Email',
  f_phone: '電話',
  f_status: '狀態',
  f_notes: '備註',
  f_photo: '會員相片',
  f_photo_remove: '移除相片',
  photo_title: '我的相片',
  photo_uploading: '上載中…',
  photo_saved: '相片已更新',
  photo_err_big: '相片太大，請揀另一張',
  photo_err_config: '相片服務未設定，請聯絡管理員',
  photo_err_generic: '上載失敗，請再試',
  f_published: '已發佈',
  status_active: '生效',
  status_pending: '待審批',
  status_expired: '已過期',
  status_disabled: '停用',
  published_yes: '已發佈',
  published_no: '草稿',
  card_member_no: '會員編號',
  card_expires: '有效至',
  card_no_link: '您的帳戶尚未連結會員記錄（請聯絡管理員）。',
  join_open_wa: '用 WhatsApp 登記',
  join_name_ph: '姓名',
  join_company_ph: '公司',
  join_submit: '用 WhatsApp 送出',
  join_name_required: '請輸入姓名',
  join_wa_unavailable: 'WhatsApp 登記暫時未能使用',
  join_wa_prefill: '登記\n姓名：{{name}}\n公司：{{company}}',
  token_working: '登入中…',
  token_invalid: '連結不正確或已過期，請重新登記。',
  legal_updated: '最後更新：2026-10-05',
  privacy_title: '私隱政策',
  privacy_intro: '香港智慧餐飲協會（HKSCA）會員系統（hksca.pages.dev）收集及使用您個人資料的方式如下。使用本系統或以 WhatsApp 登記，即代表您同意本政策。',
  privacy_collect_h: '我們收集的資料',
  privacy_collect: '您的姓名／公司名稱、電話（WhatsApp）號碼、電郵、會籍種類及到期日，以及您登記時提供的其他資料。',
  privacy_use_h: '使用方式',
  privacy_use: '僅用於處理會籍、發出及展示會員卡、發送會籍及活動通知，以及協會與您聯絡。',
  privacy_share_h: '會否提供予第三方',
  privacy_share: '我們不會出售或出租您的資料。僅在提供服務必要時（例如雲端主機、WhatsApp 訊息傳送）交由服務商處理，並受合約約束。',
  privacy_retention_h: '保存期限',
  privacy_retention: '保存至會籍結束後一段合理時間，或您要求刪除為止（法律要求保留者除外）。',
  privacy_rights_h: '您的權利',
  privacy_rights: '您可以要求查閱、更正或刪除您的個人資料，詳見「資料刪除指示」。',
  privacy_contact_h: '聯絡我們',
  privacy_contact: '請電郵 simon@coeldery85.org 查詢或提出要求。',
  deletion_title: '資料刪除指示',
  deletion_intro: '您可以隨時要求刪除 HKSCA 會員系統內您的個人資料。',
  deletion_how_h: '如何提出',
  deletion_step_1: '使用您登記的 WhatsApp 號碼或電郵，向下方聯絡方式發送訊息／電郵。',
  deletion_step_2: '寫明「要求刪除會員資料」，並提供您的會員編號或登記電話。',
  deletion_step_3: '我們將於 30 日內確認並刪除，然後回覆您。',
  deletion_scope_h: '刪除範圍',
  deletion_scope: '會員記錄、會籍、會員卡及登入帳戶；依法須保留的交易紀錄除外。',
  deletion_contact: 'WhatsApp／電郵：simon@coeldery85.org（或使用您登記的 WhatsApp 向協會號碼發送訊息）。',
  terms_title: '服務條款',
  terms_intro: '本條款規管您使用香港智慧餐飲協會（HKSCA）會員系統（hksca.pages.dev）。使用本系統或以 WhatsApp 登記，即代表您接受本條款。',
  terms_accept_h: '接受條款',
  terms_accept: '一經使用本系統或完成登記，您同意遵守本條款及相關政策（包括私隱政策）。如您不同意，請停止使用。',
  terms_account_h: '會籍與帳戶',
  terms_account: '會籍由協會按實際情況審批；您須提供真實、準確的資料，並保持登入憑證安全。您須為自己帳戶下的活動負責。',
  terms_conduct_h: '使用守則',
  terms_conduct: '不得濫用系統：包括但不限於未經授權存取、干擾服務、上載違法或侵權內容、冒充他人或作欺詐用途。',
  terms_content_h: '內容與知識產權',
  terms_content: '系統內的商標、標誌及內容屬協會或相關夥伴所有。優惠／資訊由合作夥伴提供，實際供應以商戶條款為準。',
  terms_liability_h: '責任限制',
  terms_liability: '系統按「現狀」提供；我們力求準確，但不保證無誤。對因使用或無法使用系統而引致的損失，我們在法律允許範圍內不負責任。',
  terms_changes_h: '條款更新',
  terms_changes: '我們可能不時更新本條款，更新後將於本頁公佈並更新「最後更新」日期。繼續使用即代表接受新版本。',
  terms_contact_h: '聯絡我們',
  terms_contact: '如對本條款有疑問，請電郵 simon@coeldery85.org。',
  pw_title: '更改密碼',
  pw_none_hint: '您尚未設定密碼。設定後，下次可使用電話號碼及密碼登入（無需再開啟 WhatsApp）。',
  pw_current: '目前密碼',
  pw_save: '儲存密碼',
  pw_saved: '密碼已更新 ✅',
  pw_failed: '更新失敗，請再試。',
  ann_all: '全會',
  ann_unread: '未讀',
  ann_empty: '暫無公告',
  task_new: '新增待辦事項',
  task_field_title: '待辦事項',
  task_field_notes: '備註',
  task_field_owner: '負責人',
  task_field_due: '截止日期',
  task_field_priority: '優先次序',
  task_field_committee: '所屬委員會',
  task_priority_1: '高',
  task_priority_2: '中',
  task_priority_3: '低',
  task_status_todo: '待處理',
  task_status_doing: '進行中',
  task_status_done: '已完成',
  task_status_cancelled: '已取消',
  task_unassigned: '未指派',
  task_overdue: '已逾期',
  task_empty: '暫無待辦事項',
  task_mine: '指派給我的',
  task_filter_all: '全部',
  task_scope_all: '全部委員會',
  task_summary: '共 {{total}} 項，已完成 {{done}} 項',
  task_need_title: '請輸入待辦事項。',
  task_need_committee: '請選擇所屬委員會。',
  task_failed: '操作失敗，請再試。',
  mtg_new: '安排會議',
  mtg_field_title: '會議名稱',
  mtg_field_location: '地點',
  mtg_field_starts: '會議時間',
  mtg_field_ends: '結束時間',
  mtg_field_committee: '所屬委員會',
  mtg_field_minutes: '會議記錄',
  mtg_status_scheduled: '待舉行',
  mtg_status_done: '已完成',
  mtg_status_cancelled: '已取消',
  mtg_empty: '暫無會議',
  mtg_scope_all: '全部委員會',
  mtg_filter_all: '全部',
  mtg_count: '{{n}} 項議程',
  mtg_back: '返回會議列表',
  mtg_agenda: '議程',
  mtg_agenda_add: '新增議程項',
  mtg_agenda_title: '議程項',
  mtg_agenda_notes: '備註',
  mtg_agenda_decision: '議決',
  mtg_agenda_empty: '暫無議程',
  mtg_action_from_agenda: '生成待辦',
  mtg_attendance: '出席',
  mtg_attendance_seed: '由委員名冊載入',
  mtg_attendance_rate: '出席 {{present}}／{{roster}}（{{rate}}%）',
  mtg_attendance_empty: '尚未載入出席名冊',
  mtg_att_invited: '未回覆',
  mtg_att_present: '出席',
  mtg_att_absent: '缺席',
  mtg_att_excused: '請假',
  mtg_actions: '行動項',
  mtg_actions_hint: '行動項會即時寫入「待辦」，並連結回本會議。',
  mtg_action_add: '新增行動項',
  mtg_action_empty: '暫無行動項',
  mtg_minutes_save: '儲存記錄',
  mtg_saved: '已儲存 ✅',
  mtg_failed: '操作失敗，請再試。',
  mtg_need_title: '請輸入會議名稱。',
  mtg_need_time: '請選擇會議時間。',
  ctab_discussions: '討論',
  disc_new: '開新議題',
  disc_field_title: '議題標題',
  disc_field_body: '議題說明',
  disc_open: '進行中',
  disc_closed: '已關閉',
  disc_empty: '暫無議題',
  disc_scope_all: '全部委員會',
  disc_filter_all: '全部',
  disc_posts: '{{n}} 則留言',
  disc_last: '最後活動',
  disc_back: '返回討論列表',
  disc_post_ph: '輸入留言…',
  disc_post_send: '留言',
  disc_post_empty: '暫無留言，歡迎展開討論。',
  disc_close: '關閉議題',
  disc_reopen: '重新開啟',
  disc_closed_hint: '此議題已關閉，不再接受留言。',
  disc_delete_topic: '刪除此議題',
  disc_need_title: '請輸入議題標題。',
  disc_failed: '操作失敗，請再試。',
  polls: '表決',
  poll_new: '提出議案',
  poll_field_title: '議案標題',
  poll_field_body: '議案說明',
  poll_field_closes: '截止時間',
  poll_status_open: '投票中',
  poll_status_closed: '已結束',
  poll_empty: '暫無議案',
  poll_scope_all: '全部委員會',
  poll_filter_all: '全部',
  poll_cast: '已投票 {{n}} 人',
  poll_my: '您投了：{{option}}',
  poll_not_voted: '您尚未投票',
  poll_back: '返回表決列表',
  poll_closed_hint: '此議案已結束，不再接受投票。',
  poll_closes_at: '截止',
  poll_voters: '投票紀錄',
  poll_no_voters: '暫無投票紀錄',
  poll_need_title: '請輸入議案標題。',
  poll_failed: '操作失敗，請再試。',
  poll_close: '結束投票',
  poll_reopen: '重新開放',
  poll_delete: '刪除此議案',
  poll_tied: '（並列）',
  opt_agree: '同意',
  opt_disagree: '反對',
  opt_abstain: '棄權',
  rsvp_title: '邀請回覆',
  rsvp_greeting: '{{name}}，您好',
  rsvp_event: '活動',
  rsvp_date: '日期',
  rsvp_venue: '地點',
  rsvp_guests: '同行人數',
  rsvp_accept: '我會出席',
  rsvp_decline: '未能出席',
  rsvp_sent_accept: '已記錄：您將出席，感謝回覆。',
  rsvp_sent_decline: '已記錄：您未能出席，感謝回覆。',
  rsvp_accepted: '已接受',
  rsvp_declined: '已婉拒',
  rsvp_invalid: '此連結無效或已失效，請聯絡協會秘書處。',
  rsvp_failed: '操作失敗，請再試。',
  ltr_title: '活動信件',
  ltr_intro: '建立信件模板、匯入名單、分批寄出邀請，並追蹤回覆（每位收件人一條專屬 RSVP 連結）。',
  ltr_tab_templates: '信件模板',
  ltr_tab_groups: '收件名單',
  ltr_tab_sends: '寄送批次',
  ltr_purpose_invite: '邀請函',
  ltr_purpose_sponsor: '贊助邀約',
  ltr_purpose_thanks: '答謝信',
  ltr_purpose_other: '其他',
  ltr_tpl_name: '模板名稱',
  ltr_ai_brief: '（可選）補充要求，例如：強調粵港澳大灣區交流',
  ltr_ai_draft: 'AI 草稿',
  ltr_ai_working: 'AI 生成中…',
  ltr_ai_local: '已生成草稿（Workers AI，資料未離開 Cloudflare）—— 請覆核後再儲存。',
  ltr_ai_third_party: '⚠️ 已生成草稿（經第三方 AI）—— 請覆核後再儲存。',
  ltr_tpl_subject: '主旨',
  ltr_tpl_body: '內文',
  ltr_tpl_fields: '可用合併欄位：{{fields}}',
  ltr_tpl_new: '新增模板',
  ltr_saved: '已儲存 ✅',
  ltr_failed: '操作失敗，請再試。',
  ltr_grp_count: '{{n}} 位收件人',
  ltr_grp_name: '名單名稱',
  ltr_grp_text: '貼上收件人（每行一位：email, 姓名, 公司, 職稱, 電話）',
  ltr_grp_new: '新增名單',
  ltr_grp_parsed: '已加入 {{n}} 位（略過 {{skipped}} 行）',
  ltr_status_draft: '草稿',
  ltr_status_sending: '寄送中',
  ltr_status_done: '已完成',
  ltr_status_cancelled: '已取消',
  ltr_status_pending: '待寄',
  ltr_status_sent: '已寄出',
  ltr_status_failed: '寄送失敗',
  ltr_status_simulated: '模擬寄送',
  ltr_send_pick_tpl: '選模板…',
  ltr_send_pick_grp: '選名單…',
  ltr_send_new: '建立寄送批次',
  ltr_need_pick: '請先選擇模板與名單。',
  ltr_send_missing: '注意：模板用到 {{fields}}，但收件人沒有提供 —— 請補齊資料或修改模板。',
  ltr_send_created: '已建立 {{n}} 封（逐人個人化，預覽 ＝ 實際寄出）',
  ltr_send_result: '本批處理 {{n}} 封，尚餘 {{remaining}} 封。',
  ltr_rsvp_note: '每封信會附上該收件人專屬的 RSVP 連結；回覆會即時顯示於上方統計。',
  ltr_back: '返回信件列表',
  ltr_stat_pending: '待寄',
  ltr_stat_sent: '已寄',
  ltr_stat_simulated: '模擬',
  ltr_stat_failed: '失敗',
  ltr_stat_accepted: '已接受',
  ltr_stat_declined: '已婉拒',
  ltr_email_unconfigured: '未設定寄送憑證（EMAIL_API_KEY／EMAIL_FROM）—— 現時只可使用「模擬寄送」。',
  ltr_send_now: '寄出（每批 {{n}} 封）',
  ltr_send_dry: '模擬寄送（不會真正寄出）',
  ltr_export: '匯出 CSV',
  ltr_rotate: '重新產生 RSVP 連結',
  ltr_rotate_note: '已重新產生連結（舊連結即時失效）；如未寄出，請把新連結貼到要用的地方。',
  ltr_copy: '複製',
  ltr_copied: '已複製',
  ltr_recipients: '收件人',
  ltr_tab_events: '活動',
  ltr_evt_name: '活動名稱',
  ltr_evt_venue: '地點',
  ltr_evt_new: '新增活動',
  ltr_evt_note: '活動資料會餵入 {{event_name}}／{{event_date}}／{{event_venue}} 三個合併欄位。',
  ltr_evt_closed: '已結束',
  ltr_send_pick_evt: '（可選）連結活動…',
  admin_letters: '活動信件',
  admin_sponsors: '贊助',
  sp_intro: '管理贊助方案（可用 AI 草擬）、追蹤 pipeline 進度與金額，並落實每個贊助商的權益清單。',
  sp_pipeline: '進度概覽',
  sp_total_pledged: '承諾總額',
  sp_total_paid: '已收總額',
  sp_outstanding: '未收',
  sp_stage_lead: '初步接觸',
  sp_stage_contacted: '已聯絡',
  sp_stage_pitched: '已遞交方案',
  sp_stage_pledged: '口頭承諾',
  sp_stage_confirmed: '已確認',
  sp_stage_paid: '已收款',
  sp_stage_declined: '已婉拒',
  sp_tiers: '贊助方案',
  sp_tier_new: '新增方案',
  sp_tier_code: '代號（可選，例如 diamond）',
  sp_name_hk: '名稱（繁中）',
  sp_name_cn: '名稱（簡體）',
  sp_name_en: '名稱（英文）',
  sp_tier_amount: '建議金額（港元）',
  sp_tier_benefits: '權益（每行一項）',
  sp_benefit_n: '{{n}} 項權益',
  sp_benefit_unit: '項權益',
  sp_ai_tiers: 'AI 草擬方案',
  sp_ai_review: 'AI 草稿 —— 請覆核後才儲存',
  sp_ai_save_all: '全部儲存',
  sp_ai_working: 'AI 生成中…',
  sp_ai_local: '已生成草稿（Workers AI，資料未離開 Cloudflare）—— 請覆核。',
  sp_ai_third_party: '⚠️ 已生成草稿（經第三方 AI）—— 請覆核。',
  sp_ai_saved: '已儲存 {{n}} 個方案',
  sp_sponsors: '贊助商',
  sp_sponsor_new: '新增贊助商',
  sp_company: '企業名稱',
  sp_contact_name: '聯絡人',
  sp_contact_email: '聯絡電郵',
  sp_contact_phone: '聯絡電話',
  sp_tier: '方案',
  sp_pledge: '承諾金額',
  sp_paid: '已收金額',
  sp_stage: '階段',
  sp_amounts: '金額與跟進',
  sp_owner_code: '跟進人代號（不使用真名）',
  sp_next_action: '下次動作',
  sp_note: '備註',
  sp_benefits: '權益落實',
  sp_benefits_hint: '可以一撳由方案自動生成，之後逐項打勾。',
  sp_seed: '由方案生成權益（{{n}} 項）',
  sp_seeded: '已生成 {{n}} 項權益',
  sp_add_benefit: '新增權益項',
  sp_back: '返回贊助列表',
  sp_delete: '刪除此贊助商',
  sp_failed: '操作失敗，請再試。',
  sp_saved: '已儲存 ✅',
  sp_need_tier: '請填齊三語方案名稱。',
  sp_need_company: '請輸入企業名稱。',
  sp_ai_suggest: 'AI 建議下一步',
  sp_ai_suggesting: 'AI 分析中…',
  sp_ai_apply: '套用建議',
  sp_suggest: 'AI 建議：{{stage}}',
  sp_suggest_reason: '理由：{{reason}}',
  admin_seating: '座位',
  admin_checkin: '報到',
  seat_intro: '管理檯同嘉賓、一撳自動分檯（可先預覽），活動當日喺「報到」頁打碼即確認。',
  seat_assign: '自動分檯',
  seat_preview_btn: '預覽分檯（唔會改動）',
  seat_commit_btn: '確認分檯',
  seat_clear: '清空分檯',
  seat_rule_note: '規則：VIP 優先並優先去 VIP 區 → 同行人數多者先安排 → 每檯不超容量；坐唔落會列出姓名，不會靜默消失。每一項都會記錄理由。',
  seat_result: '已分檯 {{assigned}} 位，未分檯 {{unassigned}} 位',
  seat_occupancy: '已坐 {{seats}}／{{cap}}',
  seat_free: '剩 {{n}} 位',
  seat_totals: '合計：已分檯 {{seats}} 位／總容量 {{cap}} 位／未分檯 {{un}} 位',
  seat_tables: '檯',
  seat_capacity_n: '容量 {{n}} 人',
  seat_table_label: '檯號（例：1 號檯）',
  seat_capacity: '容量',
  seat_zone_vip: 'VIP 區',
  seat_zone_main: '主區',
  seat_zone_other: '其他',
  seat_table_new: '新增檯',
  seat_guests: '嘉賓',
  seat_checked: '已報到 {{n}}',
  seat_party_n: '{{n}} 人',
  seat_no_table: '（未分檯）',
  seat_party: '同行人數',
  seat_guest_new: '新增嘉賓',
  seat_paste: '貼上嘉賓（每行一位：姓名, 公司, 聯絡, 同行人數, VIP）',
  seat_import: '匯入',
  seat_parsed: '已匯入 {{n}} 位（略過 {{skipped}} 行）',
  seat_committed: '已確認分檯（{{n}} 位）',
  seat_preview: '以上係預覽 —— 撳「確認分檯」才會寫入。',
  seat_saved: '已儲存 ✅',
  seat_failed: '操作失敗，請再試。',
  ci_intro: '打／掃嘉賓嘅報到碼（QR 或手打都可以；大小寫不拘）即顯示姓名同檯號。',
  ci_placeholder: '報到碼（例：G1A2B3C4）',
  ci_submit: '報到',
  ci_notfound: '找不到此報到碼，請核對或喺下面名單度揀。',
  ci_failed: '操作失敗，請再試。',
  ci_done_at: '已於 {{at}} 報到',
  ci_checked: '已報到 {{n}}／{{total}} 位',
  ci_pending: '未報到',
  ci_check: '報到',
  admin_budget: '對數',
  bg_intro: '活動預算 vs 實際支出，加上贊助已收款，即時顯示盈餘／赤字。',
  bg_summary: '對數匯總',
  bg_items: '預算項目',
  bg_category: '分類',
  bg_budget: '預算',
  bg_actual: '實際',
  bg_variance: '差額',
  bg_expense: '支出',
  bg_income: '收入',
  bg_other: '其他',
  bg_cat_expense: '支出',
  bg_cat_income: '收入',
  bg_cat_other: '其他',
  bg_sponsor_paid: '贊助已收款（自動計入收入）',
  bg_net_budget: '預算淨額',
  bg_net_actual: '實際淨額',
  bg_surplus: '盈餘',
  bg_deficit: '赤字',
  bg_item: '項目（例：場地租金）',
  bg_new: '新增項目',
  bg_saved: '已儲存 ✅',
  bg_failed: '操作失敗，請再試。',
  bg_hint: '差額 ＝ 實際 − 預算（正數代表超支）。贊助已收款會自動計入收入，唔使手動入。',
  admin_report: '活動報告',
  rp_ai: 'AI 總結',
  rp_print: '列印／另存 PDF',
  rp_no_event: '（未指定活動）',
  rp_no_date: '日期未定',
  rp_ai_narrative: 'AI 總結',
  rp_scale: '規模與出席',
  rp_guests: '嘉賓 {{n}} 位（{{seats}} 席）',
  rp_checked: '已報到 {{n}} 位',
  rp_unassigned: '未分檯 {{n}} 位',
  rp_tables: '檯 {{n}} 張：已坐 {{seats}}／{{cap}} 席',
  rp_sponsors: '贊助成果',
  rp_sponsor_totals: '{{n}} 間企業：承諾 {{pledged}}／已收 {{paid}}／未收 {{outstanding}}',
  rp_failed: '載入失敗，請再試。',
  sp_thank_letter: '準備答謝信',
  sp_thank_ok: '已加入「答謝信名單」—— 去「活動信件」揀答謝模板就可以寄。',
  committee_title: '理事會',
  ctab_home: '首頁',
  ctab_announcements: '公告',
  ctab_meetings: '會議',
  ctab_tasks: '待辦',
  committee_need_login: '請先登入（使用您的會員電話號碼）。',
  committee_my: '我的委員會',
  committee_none: '您未屬於任何委員會，請聯絡協會。',
  committee_invitations: '待回覆邀請',
  committee_accept: '接受',
  committee_decline: '婉拒',
  committee_joined: '已加入 ✅',
  committee_declined: '已婉拒',
  committee_soon_h: '即將推出',
  committee_soon_b: '此功能將於 Phase 2 逐項加入（公告／會議／待辦）。',
  admin_committees: '委員會',
  committee_new: '新增委員會',
  committee_kind: '種類',
  kind_board: '理事會',
  kind_functional: '功能委員會',
  kind_working: '工作委員會／小組',
  committee_code: '代號',
  committee_name_hk: '名稱（繁中）',
  committee_name_cn: '名稱（簡體）',
  committee_name_en: '名稱（英文）',
  committee_sort: '排序',
  committee_count: '委員',
  committee_members: '成員',
  committee_pick_member: '選擇會員…',
  committee_invite: '邀請加入',
  committee_status_active: '現任',
  committee_status_invited: '待回覆',
  committee_invited_ok: '已發出邀請',
  invite_member: '邀請',
  invite_working: '產生中…',
  invite_need_email: '請先填寫會員 email，方可發出邀請。',
  invite_failed: '邀請失敗，請再試。',
  invite_link_title: '邀請連結（7 日內有效）',
  invite_copy: '複製連結',
  invite_copied: '已複製',
  invite_link_note: '只可傳送給該會員本人；他點按連結設定密碼後，帳戶即時啟用。',
  invite_bound: '已連結帳戶',
  footer_privacy: '私隱政策',
  footer_deletion: '資料刪除指示',
  footer_terms: '服務條款',
};
